import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Confirm24 = ({
  color = colors.grey90,
  height = 24,
  isColorInherited = false,
  width = 24,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M18.4805 5.36594C18.785 5.05916 19.2806 5.05732 19.5874 5.36181C19.8942 5.66631 19.8961 6.16187 19.5915 6.46865L9.14193 16.9959C8.91687 17.2237 8.6403 17.3955 8.3362 17.4958C8.0318 17.5963 7.70789 17.6229 7.39116 17.5736C7.07443 17.5244 6.77394 17.4005 6.51446 17.2123C6.25526 17.0243 6.04439 16.7775 5.89919 16.4921M5.89919 16.4921L4.25756 13.2819C4.06075 12.897 4.21323 12.4255 4.59811 12.2287C4.98299 12.032 5.45453 12.1844 5.65134 12.5693L7.29414 15.7819C7.32698 15.8465 7.37486 15.9027 7.43355 15.9452C7.49224 15.9878 7.5602 16.0158 7.63184 16.0269C7.70348 16.0381 7.77674 16.0321 7.84559 16.0093C7.91444 15.9866 7.9769 15.9479 8.02783 15.8963L18.4805 5.36594"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
